import { TableHeader } from '@beego/ngx-table';
import { translate } from '@shared-libs/helpers';

export class ClientHistoryTableFactory {
	public static getHeaders(): Array<TableHeader> {
		return [
			new TableHeader(translate('CLIENT.HISTORY.TYPE'), null, 2),
			new TableHeader(translate('CLIENT.HISTORY.NAME'), null, 3),
			new TableHeader(translate('CLIENT.HISTORY.TIMESTAMP'), null, 2),
			new TableHeader(translate('CLIENT.HISTORY.QUESTION'), null, 3),
			new TableHeader(translate('CLIENT.HISTORY.STATUS'), null, 2),
			new TableHeader(translate('CLIENT.HISTORY.RATING'), null, 2),
			new TableHeader(),
		];
	}
}
